import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["id", "solid", "selectedIndex", "selectedSubIndex", "onClickCollapseEvent", "onClickItem", "onClickSubItem", "onClickLogo", "hasLogo", "role", "width", "navList", "titleTemplate", "userTemplate", "className", "style", "collapsed", "hasHeader", "hasFooter", "defaultCollapsed", "toggleFromSuffixIconOnly", "showTooltip", "direction", "distance", "collapseBtnText", "selectedKey", "defaultSelectedKey", "defaultOpenKeys", "openKeys", "onOpenChange", "onItemClick"];
// @ts-nocheck
import React from 'react';
import { KEY_VALUES, useUpdateEffect, useMergedState, _uuid } from '../utils';
import mergeRefs from '../utils/mergeRefs';
import ClassNames from 'classnames';
import { useControlled } from '../utils';
import { Tooltip } from '../tooltip';
import PopupMenu from './popup-menu';
import Trigger from '../trigger';
import builtinPlacements from '../utils/builtinPlacements';
import NavigationContext from './context/NavigationContext';
import selectedIndexListreducer from './reducer/selectedIndexListReducer';
import useItems from './utils';
var isChildList = function isChildList(selectedIndexList, nextSelectedIndexList) {
  if (nextSelectedIndexList.length >= selectedIndexList.length) {
    return false;
  }
  for (var i = 0; i < nextSelectedIndexList.length; i++) {
    if (nextSelectedIndexList[i] != selectedIndexList[i]) {
      return false;
    }
  }
  return true;
};
var updateKeys = function updateKeys(arr, item) {
  var index = arr.indexOf(item);
  if (index > -1) {
    // Item exists in the array, so delete it
    arr.splice(index, 1);
  } else {
    // Item doesn't exist in the array, so add it
    arr.push(item);
  }
  return arr;
};
var action = ['click', 'enter', 'hover'];
var Navigation = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var id = props.id,
    _props$solid = props.solid,
    solid = _props$solid === void 0 ? false : _props$solid,
    _props$selectedIndex = props.selectedIndex,
    selectedIndex = _props$selectedIndex === void 0 ? 0 : _props$selectedIndex,
    selectedSubIndex = props.selectedSubIndex,
    onClickCollapseEvent = props.onClickCollapseEvent,
    onClickItem = props.onClickItem,
    onClickSubItem = props.onClickSubItem,
    onClickLogo = props.onClickLogo,
    _props$hasLogo = props.hasLogo,
    hasLogo = _props$hasLogo === void 0 ? true : _props$hasLogo,
    _props$role = props.role,
    role = _props$role === void 0 ? 'menuItem' : _props$role,
    _props$width = props.width,
    width = _props$width === void 0 ? 280 : _props$width,
    items = props.navList,
    titleTemplate = props.titleTemplate,
    userTemplate = props.userTemplate,
    className = props.className,
    style = props.style,
    collapsedProp = props.collapsed,
    _props$hasHeader = props.hasHeader,
    hasHeader = _props$hasHeader === void 0 ? true : _props$hasHeader,
    _props$hasFooter = props.hasFooter,
    hasFooter = _props$hasFooter === void 0 ? true : _props$hasFooter,
    defaultCollapsed = props.defaultCollapsed,
    _props$toggleFromSuff = props.toggleFromSuffixIconOnly,
    toggleFromSuffixIconOnly = _props$toggleFromSuff === void 0 ? false : _props$toggleFromSuff,
    _props$showTooltip = props.showTooltip,
    showTooltip = _props$showTooltip === void 0 ? false : _props$showTooltip,
    _props$direction = props.direction,
    direction = _props$direction === void 0 ? 'right' : _props$direction,
    _props$distance = props.distance,
    distance = _props$distance === void 0 ? 8 : _props$distance,
    _props$collapseBtnTex = props.collapseBtnText,
    collapseBtnText = _props$collapseBtnTex === void 0 ? 'Collapse' : _props$collapseBtnTex,
    selectedKeyProp = props.selectedKey,
    _props$defaultSelecte = props.defaultSelectedKey,
    defaultSelectedKey = _props$defaultSelecte === void 0 ? '' : _props$defaultSelecte,
    defaultOpenKeys = props.defaultOpenKeys,
    openKeys = props.openKeys,
    onOpenChange = props.onOpenChange,
    onItemClick = props.onItemClick,
    restProps = _objectWithoutPropertiesLoose(props, _excluded);
  var _useItems = useItems(items),
    keyEntities = _useItems.keyEntities,
    treeNodes = _useItems.treeNodes;
  var _useControlled = useControlled(collapsedProp, defaultCollapsed || false),
    collapsed = _useControlled[0],
    setCollapsed = _useControlled[1];
  var _useMergedState = useMergedState([], {
      defaultValue: defaultOpenKeys,
      value: openKeys
    }),
    innerOpenKeys = _useMergedState[0],
    setInnerOpenKeys = _useMergedState[1];
  var useSelectedKey = props.hasOwnProperty('selectedKey') || props.hasOwnProperty('defaultSelectedKey');
  var _useControlled2 = useControlled(selectedKeyProp, defaultSelectedKey),
    selectedKey = _useControlled2[0],
    setselectedKey = _useControlled2[1],
    isselectedKeyControlled = _useControlled2[2];
  var navRef = React.useRef(null);
  var footerRef = React.useRef(null);
  var triggerRef = React.useRef(null);
  var initSelectedIndexList = function initSelectedIndexList(selectedIndex, selectedSubIndex) {
    if (useSelectedKey) {
      return selectedKey.split('-');
    } else {
      if (!selectedIndex && selectedIndex !== 0 && !selectedSubIndex) {
        return [];
      }
      if (selectedSubIndex === undefined) {
        return [Number(selectedIndex)];
      } else {
        if (typeof selectedSubIndex === 'number') {
          return [selectedIndex ? Number(selectedIndex) : 0, selectedSubIndex];
        } else {
          return [selectedIndex ? Number(selectedIndex) : 0].concat(selectedSubIndex.split('-').map(function (index) {
            return Number(index);
          }));
        }
      }
    }
  };
  var _React$useReducer = React.useReducer(selectedIndexListreducer, {
      keyEntities: keyEntities,
      selectedIndexList: initSelectedIndexList(selectedIndex, selectedSubIndex),
      openPopup: false,
      isControlled: useSelectedKey && isselectedKeyControlled,
      clickPathList: [],
      keyboard: false
    }),
    selectedIndexListStore = _React$useReducer[0],
    selectedIndexListDispatch = _React$useReducer[1];
  useUpdateEffect(function () {
    if (useSelectedKey) {
      var keys = selectedKey.split('-');
      var subKeys = keys.slice(1) || [];
      selectedIndexListDispatch({
        type: 'updateSelectedKeyForToggleOnly',
        payload: {
          nextSelectedIndexList: keys,
          selectedSubIndex: subKeys.join('-') || [],
          keyEntities: keyEntities
        }
      });
    } else {
      var _keys = selectedSubIndex === undefined ? selectedIndex + '' : selectedIndex + '-' + selectedSubIndex;
      selectedIndexListDispatch({
        type: 'updateSelectedKeyForToggleOnly',
        payload: {
          nextSelectedIndexList: _keys.split('-'),
          selectedSubIndex: selectedSubIndex,
          keyEntities: keyEntities
        }
      });
    }
  }, [selectedIndex, selectedSubIndex, selectedKey]);
  var _React$useMemo = React.useMemo(function () {
      var fullSelectedIndexList = selectedIndexListStore.selectedIndexList;
      var subSelectedIndexList = (fullSelectedIndexList === null || fullSelectedIndexList === void 0 ? void 0 : fullSelectedIndexList.slice(1)) || [];
      return [fullSelectedIndexList, subSelectedIndexList];
    }, [selectedIndexListStore.selectedIndexList]),
    fullSelectedIndexList = _React$useMemo[0];
  var firstRef = React.useRef(true);
  var classes = ClassNames('ap-navigation-wrapper', {
    'collapse-nav': collapsed,
    'solid-nav': solid
  }, className);
  React.useEffect(function () {
    firstRef.current = false;
  }, []);
  var onCollapseClick = function onCollapseClick(event) {
    var newValue = !collapsed;
    setCollapsed(newValue);
    onClickCollapseEvent === null || onClickCollapseEvent === void 0 ? void 0 : onClickCollapseEvent(newValue, event);
  };
  var onCollapseKeydown = function onCollapseKeydown(event) {
    var key = event.key;
    if (KEY_VALUES.ENTER === key) {
      onCollapseClick(event);
    }
  };
  var onSelectedKeyChange = function onSelectedKeyChange(event, item, key) {
    setselectedKey(key);
    onItemClick === null || onItemClick === void 0 ? void 0 : onItemClick(event, item, key);
  };
  var handleItemClick = function handleItemClick(event, navItem) {
    event.stopPropagation();
    var isEnter = (event === null || event === void 0 ? void 0 : event.key) === KEY_VALUES.ENTER;
    if (event.type !== 'click' && !isEnter) {
      return;
    }
    var key = navItem.key;
    var nextSelectedIndexList = key.split('-').map(function (item) {
      return Number(item);
    });
    var nextMainIndex = nextSelectedIndexList[0];
    var nextSubIndex = nextSelectedIndexList.slice(1).join('-');
    var isSub = nextSelectedIndexList.length > 1;
    if (!selectedIndexListStore.isControlled) {
      if (useSelectedKey) {
        if (toggleFromSuffixIconOnly) {
          setSeletedKey(key);
          onItemClick === null || onItemClick === void 0 ? void 0 : onItemClick(event, navItem, key);
        } else if (!navItem.children) {
          setSeletedKey(key);
          onItemClick === null || onItemClick === void 0 ? void 0 : onItemClick(event, navItem, key);
        }
      } else {
        if (toggleFromSuffixIconOnly) {
          selectedIndexListDispatch({
            type: 'setSelectedKeyForToggleOnly',
            payload: {
              nextSelectedIndexList: nextSelectedIndexList
            }
          });
        } else {
          selectedIndexListDispatch({
            type: 'setSelectedIndexList',
            payload: {
              nextSelectedIndexList: nextSelectedIndexList,
              keyEntities: keyEntities
            }
          });
        }
      }
    } else {
      if (toggleFromSuffixIconOnly) {
        if (useSelectedKey) {
          setselectedKey(key);
          onItemClick === null || onItemClick === void 0 ? void 0 : onItemClick(event, navItem, key);
        }
      } else {
        if (!navItem.children) {
          if (useSelectedKey) {
            setselectedKey(key);
            onItemClick === null || onItemClick === void 0 ? void 0 : onItemClick(event, navItem, key);
          }
        }
      }
    }
    if (isSub) {
      onClickSubItem === null || onClickSubItem === void 0 ? void 0 : onClickSubItem(event, navItem, nextSubIndex, nextMainIndex);
    } else {
      onClickItem === null || onClickItem === void 0 ? void 0 : onClickItem(event, navItem, nextMainIndex);
    }
    if (!toggleFromSuffixIconOnly && navItem.children && navItem.children.length > 0) {
      var keys = updateKeys(innerOpenKeys, key);
      setInnerOpenKeys(keys);
      onOpenChange === null || onOpenChange === void 0 ? void 0 : onOpenChange(navItem, keys, event);
    }
  };
  var handleItemToggle = function handleItemToggle(event, navItem) {
    event.stopPropagation();
    var key = event.key;
    var isEnter = key === KEY_VALUES.ENTER;
    if (event.type === 'click' || isEnter) {
      var _key = navItem.key;
      var keys = updateKeys(innerOpenKeys, _key);
      setInnerOpenKeys(keys);
      onOpenChange === null || onOpenChange === void 0 ? void 0 : onOpenChange(navItem, keys, event);
    }
  };
  var handleNavbarMainItemClick = function handleNavbarMainItemClick(event, navItem, index) {
    if (event.key === KEY_VALUES.TAB) {
      selectedIndexListDispatch({
        type: 'setOpenPopup',
        payload: {
          openPopup: false,
          keyEntities: keyEntities
        }
      });
      return;
    }
    if (event.type !== 'mouseenter' && event.type !== 'click' && event.key !== KEY_VALUES.ENTER && event.key !== KEY_VALUES.SPACE) {
      return;
    }
    var keyboard = true;
    if (event.type === 'mouseenter') {
      keyboard = false;
    }
    selectedIndexListDispatch({
      type: 'setOpenPopup',
      payload: {
        openPopup: true,
        keyboard: keyboard,
        keyEntities: keyEntities
      }
    });
    if (event.type === 'click' || event.key === KEY_VALUES.ENTER) {
      if (!navItem.children) {
        if (!selectedIndexListStore.isControlled) {
          selectedIndexListDispatch({
            type: 'setSelectedIndexList',
            payload: {
              nextSelectedIndexList: [Number(index)],
              keyEntities: keyEntities
            }
          });
        }
        selectedIndexListDispatch({
          type: 'setClickPathList',
          payload: {
            nextClickPathList: [index],
            keyEntities: keyEntities
          }
        });
        onClickItem === null || onClickItem === void 0 ? void 0 : onClickItem(event, navItem, Number(index));
        onItemClick === null || onItemClick === void 0 ? void 0 : onItemClick(event, navItem, navItem.key);
        triggerRef.current.triggerOpen(false);
      }
    }
  };
  var renderCollapsedNavItem = function renderCollapsedNavItem(treeNodes) {
    return treeNodes && treeNodes.map(function (navItem, index) {
      var id = _uuid();
      var _index = String(index);
      var selectedkeyIndex = [];
      if (useSelectedKey) {
        selectedkeyIndex = selectedKey.split('-');
      } else {
        selectedkeyIndex = fullSelectedIndexList;
      }
      var selectedKeyTemp = selectedkeyIndex.join('-');
      var isSelected = false;
      var currentKey = navItem.key;
      if (toggleFromSuffixIconOnly) {
        isSelected = selectedKeyTemp === currentKey;
      } else {
        var i = keyEntities.findIndex(function (keyEntity) {
          return keyEntity.key === currentKey;
        });
        if (navItem.children) {
          var _index2 = keyEntities.findIndex(function (keyEntity) {
            return keyEntity.key === selectedKeyTemp;
          });
          if (_index2 > -1 && keyEntities[_index2].childKey.length === 0) {
            if (isChildList(selectedkeyIndex, currentKey.split('-').map(function (path) {
              return Number(path);
            }))) {
              isSelected = true;
            }
          }
        } else {
          if (i > -1) {
            var node = keyEntities[i];
            if (node.childKey && node.childKey.length === 0 && selectedKeyTemp === currentKey) {
              isSelected = true;
            }
          }
        }
      }
      var navItemCls = ClassNames('ap-nav-item', 'nav-with-child', "item-" + index);
      var navigationItemCls = ClassNames('ap-navigation-item', 'collapsed', {
        selected: isSelected
      });
      var indexPath = _index;
      var prefixIconCls = ClassNames('prefixIcon', navItem.prefixIconClass || "Appkit4-icon icon-" + (isSelected && navItem.prefixCollapsedIcon ? navItem.prefixCollapsedIcon : navItem.prefixIcon) + "-" + (isSelected && navItem.prefixCollapsedIcon ? 'fill' : 'outline'));
      var ariaExpanded = {};
      if (navItem.children && navItem.children.length > 0) {
        ariaExpanded['aria-expanded'] = innerOpenKeys !== null && innerOpenKeys !== void 0 && innerOpenKeys.includes(navItem.key) ? true : false;
      }
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
        className: ClassNames(navItem.itemClassName),
        key: _index
      }, showTooltip && (!navItem.children || navItem.children && navItem.children.length === 0) && /*#__PURE__*/React.createElement(Tooltip, {
        hideTooltipOnBlur: true,
        autoHide: true,
        content: navItem.name,
        position: direction,
        distance: distance,
        target: ".ap-nav-item.nav-with-child.item-" + _index
      }), /*#__PURE__*/React.createElement(Trigger, {
        ref: triggerRef,
        popupClassName: "ap-navigation-popup",
        key: _index,
        autoDestroy: true,
        builtinPlacements: builtinPlacements(true),
        action: action,
        popupPlacement: 'right',
        popup: selectedIndexListStore.openPopup ? /*#__PURE__*/React.createElement(PopupMenu, {
          onClose: function onClose(isEsc, indexPath) {
            triggerRef === null || triggerRef === void 0 ? void 0 : triggerRef.current.triggerOpen(false);
            if (isEsc) {
              var indexPaths = indexPath.split('-');
              var ele = document.querySelector(".item-" + indexPath[0]);
              // ele?.focus();
            }
          },

          action: action,
          onClickSubItem: onClickSubItem,
          indexPath: indexPath,
          width: 220,
          menuDataItem: navItem.children,
          level: 1,
          id: id,
          onLeft: function onLeft(indexPath) {
            var ele = document.querySelector(".item-" + indexPath);
            ele === null || ele === void 0 ? void 0 : ele.focus();
            selectedIndexListDispatch({
              type: 'setOpenPopup',
              payload: {
                openPopup: false,
                keyboard: false,
                keyEntities: keyEntities
              }
            });
          },
          onSelectedKeyChange: useSelectedKey ? onSelectedKeyChange : null
        }) : ''
      }, /*#__PURE__*/React.createElement("div", {
        "aria-haspopup": navItem.children && navItem.children.length > 0 ? 'true' : 'false',
        "aria-expanded": selectedIndexListStore.openPopup && isSelected ? 'true' : 'false',
        onClick: function onClick(event) {
          handleNavbarMainItemClick(event, navItem, _index);
        },
        onMouseEnter: function onMouseEnter(event) {
          return handleNavbarMainItemClick(event, navItem, _index);
        },
        onKeyDown: function onKeyDown(event) {
          if (event.keyCode === 13) {
            handleNavbarMainItemClick(event, navItem, _index);
          }
        },
        className: navItemCls,
        tabIndex: 0,
        role: 'menuItem',
        "aria-controls": id,
        "aria-label": navItem.name
      }, /*#__PURE__*/React.createElement("a", _extends({
        className: navigationItemCls
      }, navItem.anchorProps), /*#__PURE__*/React.createElement("div", {
        className: "prefix-content"
      }, (navItem.prefixIcon || navItem.prefixIconClass) && /*#__PURE__*/React.createElement("span", {
        className: prefixIconCls,
        "aria-label": navItem.name,
        "aria-hidden": !collapsed
      }, navItem.children && navItem.children.length > 0 && /*#__PURE__*/React.createElement("span", {
        className: "Appkit4-icon icon-caret-down-fill icon-collapsed"
      }))))))), navItem.divider && /*#__PURE__*/React.createElement("div", {
        className: "ap-divider"
      }));
    });
  };
  var renderNavItem = function renderNavItem(items, level, parentKey) {
    return items && items.map(function (navItem, index) {
      var isSelected = false;
      var currentKey = navItem.key;
      var selectedkeyIndex = [];
      if (useSelectedKey) {
        selectedkeyIndex = selectedKey.split('-');
      } else {
        selectedkeyIndex = fullSelectedIndexList;
      }
      var selectedIndexKey = selectedkeyIndex.join('-');
      var i = keyEntities.findIndex(function (keyEntity) {
        return keyEntity.key === currentKey;
      });
      var isOpen = innerOpenKeys.includes(currentKey);
      if (toggleFromSuffixIconOnly) {
        isSelected = selectedIndexKey === currentKey;
      } else {
        if (navItem.children && !isOpen) {
          var _index3 = keyEntities.findIndex(function (keyEntity) {
            return keyEntity.key === selectedIndexKey;
          });
          if (_index3 > -1 && keyEntities[_index3].childKey.length === 0) {
            if (isChildList(selectedkeyIndex, currentKey.split('-').map(function (path) {
              return Number(path);
            }))) {
              isSelected = true;
            }
          }
        } else {
          if (i > -1) {
            var node = keyEntities[i];
            if (node.childKey && node.childKey.length === 0 && selectedIndexKey === currentKey) {
              isSelected = true;
            }
          }
        }
      }
      var navItemCls = ClassNames('ap-nav-item', 'nav-with-child', "item-" + index, {
        'nav-item-expanded': isOpen && !collapsed
      });
      var navigationItemCls = ClassNames('ap-navigation-item', {
        selected: isSelected
      });
      var suffixIconCls = ClassNames('suffixIcon', navItem.suffixIconClass ? navItem.suffixIconClass : "Appkit4-icon icon-" + navItem.suffixIcon + "-outline", {
        rotate: isOpen
      });
      var prefixIconCls = ClassNames('prefixIcon', navItem.prefixIconClass || "Appkit4-icon icon-" + (isSelected && navItem.prefixCollapsedIcon ? navItem.prefixCollapsedIcon : navItem.prefixIcon) + "-" + (isSelected && navItem.prefixCollapsedIcon ? 'fill' : 'outline'));
      var ariaExpanded = {};
      if (navItem.children && navItem.children.length > 0) {
        ariaExpanded['aria-expanded'] = innerOpenKeys !== null && innerOpenKeys !== void 0 && innerOpenKeys.includes(navItem.key) ? true : false;
      }
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
        key: index
      }, /*#__PURE__*/React.createElement("div", {
        className: ClassNames(navItem.itemClassName)
      }, /*#__PURE__*/React.createElement("div", {
        key: index,
        className: navItemCls,
        tabIndex: -1,
        role: 'none',
        onClick: function onClick(event) {
          return handleItemClick(event, navItem, false);
        },
        onKeyUp: function onKeyUp(event) {
          return handleItemClick(event, navItem, false);
        }
      }, /*#__PURE__*/React.createElement("a", _extends({
        className: navigationItemCls,
        style: level > 1 ? {
          paddingLeft: (level - 1) * 12
        } : null,
        tabIndex: 0,
        role: role,
        "aria-label": navItem.name
      }, ariaExpanded, navItem.anchorProps), /*#__PURE__*/React.createElement("div", {
        className: "prefix-content"
      }, (navItem.prefixIcon || navItem.prefixIconClass) && /*#__PURE__*/React.createElement("span", {
        className: prefixIconCls,
        "aria-hidden": true
      })), /*#__PURE__*/React.createElement("span", {
        className: "itemContent",
        "aria-hidden": true
      }, navItem.name), (navItem.suffixIcon || navItem.suffixIconClass) && !collapsed && /*#__PURE__*/React.createElement("span", {
        "aria-label": toggleFromSuffixIconOnly ? 'toggle button' : undefined,
        className: suffixIconCls,
        "aria-hidden": toggleFromSuffixIconOnly ? false : true,
        tabIndex: toggleFromSuffixIconOnly ? 0 : -1,
        onClick: function onClick(event) {
          return toggleFromSuffixIconOnly && handleItemToggle(event, navItem);
        },
        onKeyUp: function onKeyUp(event) {
          return toggleFromSuffixIconOnly && handleItemToggle(event, navItem);
        }
      })), navItem.children && isOpen && /*#__PURE__*/React.createElement("div", {
        className: "nav-item-child"
      }, renderNavItem(navItem.children, level + 1))))), navItem.divider && /*#__PURE__*/React.createElement("div", {
        className: "ap-divider"
      }));
    });
  };
  return /*#__PURE__*/React.createElement("nav", {
    id: id,
    className: classes,
    style: _extends({}, style, {
      width: collapsed ? 72 : width
    }),
    ref: mergeRefs(ref, navRef)
  }, hasHeader && /*#__PURE__*/React.createElement("div", {
    className: "ap-navigation-heading"
  }, /*#__PURE__*/React.createElement("div", {
    className: "ap-navigation-title-wrapper"
  }, hasLogo && /*#__PURE__*/React.createElement("div", {
    className: "ap-navigation-logo",
    onClick: onClickLogo
  }), /*#__PURE__*/React.createElement("div", {
    className: "ap-navigation-title"
  }, titleTemplate && /*#__PURE__*/React.createElement("div", {
    className: "ap-header-title"
  }, titleTemplate()))), /*#__PURE__*/React.createElement("div", {
    className: "ap-navigation-avatar-content"
  }, userTemplate === null || userTemplate === void 0 ? void 0 : userTemplate())), /*#__PURE__*/React.createElement("div", {
    className: "ap-navigation-content " + (hasHeader ? 'ap-high-padding-top' : ''),
    role: "menuBar",
    tabIndex: 0
  }, /*#__PURE__*/React.createElement(NavigationContext.Provider, {
    value: {
      selectedIndexListStore: selectedIndexListStore,
      selectedIndexListDispatch: selectedIndexListDispatch
    }
  }, collapsed ? renderCollapsedNavItem(treeNodes, 0) : renderNavItem(treeNodes, 0, ''))), hasFooter && /*#__PURE__*/React.createElement("div", {
    className: "ap-navigation-footer",
    ref: footerRef,
    style: {
      width: collapsed ? 72 : width
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "ap-navigation-item collapsed-item",
    role: "button",
    "aria-expanded": !collapsed,
    "aria-label": "navigation operation",
    tabIndex: 0,
    onClick: onCollapseClick,
    onKeyUp: onCollapseKeydown
  }, /*#__PURE__*/React.createElement("div", {
    className: "prefix-content"
  }, !collapsed ? /*#__PURE__*/React.createElement("span", {
    className: "prefixIcon Appkit4-icon icon-enter-left-outline"
  }) : /*#__PURE__*/React.createElement("span", {
    className: "prefixIcon Appkit4-icon icon-enter-right-outline"
  })), /*#__PURE__*/React.createElement("span", {
    className: "itemContent"
  }, collapseBtnText))));
});
Navigation.displayName = 'Navigation';
export default Navigation;